const PANEL_SELECTOR = '[data-initiative-info]'
const TOGGLE_SELECTOR = '[data-initiative-info-toggle]'
const MOBILE_MEDIA_QUERY = '(max-width: 767px)'
const COLLAPSED_CLASS = 'is-collapsed'
const EXPANDED_CLASS = 'is-expanded'

const setToggleVisibility = (toggle, hidden) => {
  if (!toggle) return
  const wrapper = toggle.parentElement
  toggle.classList.toggle('is-hidden', hidden)
  if (wrapper) {
    wrapper.classList.toggle('is-hidden', hidden)
  }
}

const isMobileViewport = () => {
  if (typeof window.matchMedia === 'function') {
    return window.matchMedia(MOBILE_MEDIA_QUERY).matches
  }
  return window.innerWidth <= 767
}

const setToggleState = (toggle, expanded) => {
  if (!toggle) return
  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
}

const resetPanel = (panel) => {
  panel.classList.remove(COLLAPSED_CLASS, EXPANDED_CLASS)
}

const applyExpandedState = (panel, toggle) => {
  panel.classList.remove(COLLAPSED_CLASS)
  panel.classList.add(EXPANDED_CLASS)
  setToggleVisibility(toggle, false)
  setToggleState(toggle, true)
}

const applyCollapsedState = (panel, toggle) => {
  panel.classList.remove(EXPANDED_CLASS)
  panel.classList.add(COLLAPSED_CLASS)

  // If content does not overflow, keep section fully open and hide toggle.
  const hasOverflow = panel.scrollHeight > panel.clientHeight + 1
  if (!hasOverflow) {
    resetPanel(panel)
    setToggleVisibility(toggle, true)
    setToggleState(toggle, true)
    return
  }

  setToggleVisibility(toggle, false)
  setToggleState(toggle, false)
}

const bindInstance = (panel, toggle) => {
  if (!panel || !toggle) return

  if (!isMobileViewport()) {
    resetPanel(panel)
    setToggleVisibility(toggle, true)
    setToggleState(toggle, true)
    return
  }

  applyCollapsedState(panel, toggle)
  if (toggle.hidden) {
    // No overflow at collapsed height: keep full content and skip toggle wiring.
    return
  }

  toggle.addEventListener('click', () => {
    const isExpanded = panel.classList.contains(EXPANDED_CLASS)
    if (isExpanded) {
      applyCollapsedState(panel, toggle)
      return
    }

    applyExpandedState(panel, toggle)
  })
}

export const initInitiativeInfoToggle = () => {
  const panels = document.querySelectorAll(PANEL_SELECTOR)
  if (!panels.length) return

  panels.forEach((panel) => {
    const toggle = panel.parentElement
      ? panel.parentElement.querySelector(TOGGLE_SELECTOR)
      : null
    if (!toggle) return
    bindInstance(panel, toggle)
  })
}
